import BigNumber from 'bignumber.js';

export const ZERO = new BigNumber(0);

export const STORAGE_CACHE_TOKEN_KEY = 'account.token'